module.exports = __webpack_public_path__ + "static/media/control-chofer-verde.46330dac.png";